<template>
  <div class="printBox page7 common">
    <div class="bg-t"></div>
    <div class="content">
      <div style="color: #0066CC;">
        <div style="font-size: 24px;">(二) 倡导健康生活方式</div>
      </div>
      <div>
        <div class="title">1、开设健康生活相关课程</div>
        <div class="text">
          <p>制定课程大纲，涵盖饮食、作息、运动、疾病预防、心理健康等内容。安排专业教师或邀请外部专家授课，确保课程质量。结合线上平台和实体课程，提供灵活的学习方式。定期评估课程效果，根据学生反馈调整课程内容</p>
        </div>
      </div>
      <div>
        <div class="title">2、开展运动类活动</div>
        <div class="text">
          <p>组织多样化运动活动，如体育比赛、健身课程、户外徒步等。鼓励学生参与， 提供奖励机制，增加参与积极性。利用校园空地和学生兴趣，创办特色运动项目。定期举办运动文化节，提升校园运动文化氛围。</p>
        </div>
      </div>
      <div>
        <div class="title">3、完善与增设运动设施</div>
        <div class="text">
          <p>评估现有运动设施，列出改善和新增需求。争取校方资金支持，逐步改善和增加运动场地和设备。提供运动设施使用指南，确保设施的高效利用。定期维护运动设施，确保安全和舒适的运动环境。</p>
        </div>
      </div>
      <div>
        <div class="title">4、完善学校体育运动风险应对方案</div>
        <div class="text">
          <p>制定全面的安全管理规章制度，包括运动伤害预防、应急处理流程等。对体育教师和学生进行安全运动培训，增强安全意识。配置必要的急救设备，如自动体外除颤器（AED）等。建立运动伤害报告和跟踪系统，及时处理事故。</p>
        </div>
      </div>
      <div>
        <div class="title">5、鼓励“每天运动一小时”</div>
        <div class="text">
          <p>通过宣传运动对身心健康的好处，增强学生的运动意识。 制定运动计划和时间表，方便学生安排运动时间。结合校园打卡系统，鼓励学生记录和分享自己的运动成就。对坚持“每天运动一小时”的学生给予奖励，如体育积分、荣誉证书等。</p>
        </div>
      </div>
    </div>
    <div class="bg-b"></div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.page7{
  position: relative;
}
.page7 .title{
  font-size: 21px;
  color: #000;
}
.page7 .text{
  font-size: 16px;
  color: #333;
}
.page7 .text p{
  text-indent: 2em;
  line-height: 2;
}
.page7 .content{
  padding: 80px;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 40px;
}
.page7 .bg-t{
  position: absolute;
  top: 0;
  right: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-rt.png") no-repeat;
  background-size: 100% 100%;
}
.page7 .bg-b{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 231px;
  height: 338px;
  background: url("@/assets/images/report-lb.png") no-repeat;
  background-size: 100% 100%;
}
</style>